import React, { useState, useEffect } from 'react';

function RefereeModal({ bet, onClose, currentUserEmail }) {
  const [loading, setLoading] = useState(true);
  const [verdict, setVerdict] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const consultRef = async () => {
      try {
        setLoading(true);
        setError('');

        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/bets/${bet.id}/consult-ref`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-User-Email': currentUserEmail
            },
            credentials: 'include',
          }
        );

        if (response.ok) {
          const data = await response.json();
          setVerdict(data.verdict);
        } else {
          const errorData = await response.json();
          setError(errorData.detail || 'Failed to consult the ref');
        }
      } catch (err) {
        setError('Network error. The ref seems to be on a coffee break.');
      } finally {
        setLoading(false);
      }
    };

    consultRef();
  }, [bet.id]);

  const handleOverlayClick = (e) => {
    if (e.target.className === 'RefereeModal-overlay') {
      onClose();
    }
  };

  return (
    <div className="RefereeModal-overlay" onClick={handleOverlayClick}>
      <div className="RefereeModal">
        <button className="RefereeModal-close" onClick={onClose} aria-label="Close">
          &times;
        </button>

        <div className="RefereeModal-content">
          <div className="RefereeModal-avatar">
            <img
              src="/caodarmas-referee.png"
              alt="Referee"
              style={{ width: '150px', height: '150px', objectFit: 'contain' }}
            />
          </div>

          {loading && (
            <div className="RefereeModal-loading">
              <p className="pulse-text">checking the facts...</p>
            </div>
          )}

          {!loading && error && (
            <div className="RefereeModal-error">
              <p>{error}</p>
            </div>
          )}

          {!loading && !error && verdict && (
            <div className="RefereeModal-verdict">
              <p>{verdict}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default RefereeModal;
